<template>
    <div class="row flex-grow">
        <div class=" col-xl-4 col-lg-6 mx-auto">
            <form class="auth-form-light text-left pl-5 pr-5 pb-5" @submit.prevent="createAccount">
                <div class="brand-logo text-right">
                    <img :src="'/media/aform-logo-black.png'" alt="Coachingclub.lu">
                </div>

                <h4>{{ $t('pages.register.title') }}</h4>
                <h6 class="font-weight-light">{{ $t('pages.register.subtitle') }}</h6>

                <div class="pt-3">
                    <div class="form-group mt-4">
                        <label for="preferred_language">{{ $t("pages.register.preferred_language") }}</label>
                        <select class="form-control" id="preferred_language" :placeholder="$t('user.preferred_language')"  v-model="preferred_language" :class="{'is-invalid': $errors.has('preferred_language')}">
                            <option value="lb">
                                {{ $t('languages.luxembourgish') }}
                            </option>
                            <option value="en">
                                {{ $t('languages.english') }}
                            </option>
                            <option value="de">
                                {{ $t('languages.german') }}
                            </option>
                        </select>
                        <error input="preferred_language"/>
                    </div>

                    <hr class="mt-4 mb-4">

                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="first_name">{{ $t('pages.register.first_name') }}</label>
                                <input id="first_name" type="text" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('first_name')}" :placeholder="$t('pages.register.first_name')" v-model="first_name">
                                <error input="first_name"/>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="first_name">{{ $t('pages.register.last_name') }}</label>
                                <input type="text" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('last_name')}" :placeholder="$t('pages.register.last_name')" v-model="last_name" >
                                <error input="last_name"/>
                            </div>
                        </div>
                    </div>

                    <div class="row" id="date_of_birth">
                        <div class="col-12">
                            <div class="form-group mb-0">
                                <label for="date_of_birth">{{ $t('pages.register.date_of_birth') }}</label>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="form-group">
                                <select class="form-control form-control-lg" :class="{'is-invalid': $errors.has('date_of_birth.day')}" v-model="day">
                                    <option value="" disabled selected>{{ $t('pages.register.day') }}</option>
                                    <option v-for="dayInList in daysList" :value="dayInList">{{ dayInList }}</option>
                                </select>
                                <error input="date_of_birth.day"/>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="input-group">
                                <select class="form-control form-control-lg" :class="{'is-invalid': $errors.has('date_of_birth.month')}" v-model="month">
                                    <option value="" disabled selected>{{ $t('pages.register.month') }}</option>
                                    <option v-for="(monthInList, i) in monthList" :value="i">{{ monthInList }}</option>
                                </select>
                                <error input="date_of_birth.month"/>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="input-group">
                                <select class="form-control form-control-lg" :class="{'is-invalid': $errors.has('date_of_birth.year')}" v-model="year">
                                    <option value="" disabled selected>{{ $t('pages.register.year') }}</option>
                                    <option v-for="yearInList in yearList" :value="yearInList">{{ yearInList }}</option>
                                </select>
                                <error input="date_of_birth.year"/>
                            </div>
                        </div>
                    </div>

                    <div class="form-group mt-4">
                        <label for="email">{{ $t('pages.register.email') }}</label>
                        <input id="email" type="email" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('email')}" :placeholder="$t('pages.register.email')" v-model="email">
                        <error input="email"/>
                    </div>

                    <div class="form-group mt-4">
                        <label for="phone_number">{{ $t('pages.register.phone_number') }}</label>

                        <div class="row">
                            <div class="col-md-4">
                                <select id="phone_prefix_id" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('phone_prefix')}" v-model="phone_prefix_id">
                                    <option value="" disabled selected>{{ $t('pages.register.phone_prefix') }}</option>
                                    <option v-for="phone_prefix in sortedCallingCodes" :value="phone_prefix.id">+{{ phone_prefix.calling_code }} ({{ phone_prefix.name }})</option>
                                </select>
                                <error input="phone_prefix_id"/>
                            </div>
                            <div class="col-md-8">
                                <input id="phone_number" type="tel" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('phone_number')}" :placeholder="$t('pages.register.phone_number')" v-model="phone_number">
                                <error input="phone_number"/>
                            </div>
                        </div>
                </div>

                    <hr class="mt-4 mb-4">

                    <div class="form-group">
                        <label for="password">{{ $t('pages.register.password') }}</label>
                        <div class="input-group">
                            <input id="password" :type="getPasswordInputType" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('password')}" :placeholder="$t('pages.register.password')" v-model="password">
                            <div class="input-group-append">
                                <button class="btn btn-sm btn-dark text-white" type="button" @click="showPassword = !showPassword">
                                    <i class="mdi mdi-eye"></i>
                                </button>
                            </div>
                            <error input="password"/>
                        </div>
                    </div>

                    <div class="form-group mt-4">
                        <label for="password_confirmation">{{ $t('pages.register.password_confirmation') }}</label>
                        <div class="input-group">
                            <input id="password_confirmation" :type="getPasswordInputType" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('password')}"
                                   :placeholder="$t('pages.register.password_confirmation')" v-model="password_confirmation" >
                            <div class="input-group-append">
                                <button class="btn btn-sm btn-dark text-white" type="button" @cli3ck="showPassword = !showPassword">
                                    <i class="mdi mdi-eye"></i>
                                </button>
                            </div>
                            <error input="password"/>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="form-check form-check-primary mt-4">
                            <label class="form-check-label">
                                <input type="checkbox" class="form-check-input" v-model="privacy_consent">
                                {{ $t('pages.register.privacy_consent') }}
                                <i class="input-helper"></i>
                            </label>
                            <error-no-form-field input="privacy_consent"/>
                        </div>
                    </div>


                    <div class="mt-4 text-center">
                        <p class="text-small" v-html="$t('pages.register.terms_agreement')"></p>
                    </div>

                    <div class="mt-3">
                        <button class="btn btn-block btn-outline-dark btn-lg font-weight-medium auth-form-btn">
                            {{ $t('pages.register.create_account') }}
                        </button>
                    </div>
                    <div class="my-2 d-flex justify-content-between align-items-center text-center">
                        <router-link :to="{name: 'login'}" class="text-dark">
                            {{ $t('pages.register.already_have_account') }}
                        </router-link>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import AuthRepository from "../../../repositories/Auth/AuthRepository";
import CountryRepository from "../../../repositories/Countries/CountryRepository";

export default {
    name: "Register",
    data: () => ({
        first_name: '',
        last_name: '',
        email: '',
        day: '',
        month: '',
        year: '',
        phone_prefix_id: 442,
        phone_number: '',
        password: '',
        password_confirmation: '',
        preferred_language: 'lb',
        privacy_consent: false,


        calling_codes: [],
        showPassword: false
    }),
    mounted() {
        AuthRepository.getSanctumCSRFCookie();
        this.getCountries();
    },
    watch: {
        preferred_language(value) {
            if(['de', 'en', 'lb'].includes(value)) {
                this.$i18n.locale = value;
                this.$date.locale(value);
            } else {
                this.$i18n.locale = 'en';
                this.$date.locale('en');
            }
        }
    },
    methods: {
        getCountries() {
            CountryRepository.getSimplePhonePrefix()
                .then((res) => {
                    this.calling_codes = res.data;
                })
        },
        createAccount() {
            this.$store.dispatch("register", {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                password: this.password,
                password_confirmation: this.password_confirmation,
                preferred_language: this.preferred_language,
                phone_prefix_id: this.phone_prefix_id,
                phone_number: this.phone_number,
                policy_confirmation: this.policy_confirmation,
                date_of_birth: {
                    day: this.day === '' ? null : (this.day + 1),
                    month: this.month === '' ? null : (this.month + 1),
                    year: this.year,
                },
                privacy_consent: this.privacy_consent,
            }).then((response) => {
                this.$router.push({ name: 'home' });
                this.$snotify.success(`Welcome ${this.$store.getters.user.first_name}!`)

            }).catch(error => {
                this.password = "";
                this.password_confirmation = "";
            });
        },
    },
    computed: {
        sortedCallingCodes() {
            return this.calling_codes.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
        },
        daysList() {
              return Array.from({length: 31}, (_, i) => i + 1);
        },
        monthList() {
            return [
                this.$t('date.months.january'), this.$t('date.months.february'), this.$t('date.months.march'), this.$t('date.months.april'), this.$t('date.months.may'), this.$t('date.months.june'),
                this.$t('date.months.july'), this.$t('date.months.august'), this.$t('date.months.september'), this.$t('date.months.october'), this.$t('date.months.november'), this.$t('date.months.december'),
            ];
        },
        yearList() {
            const now = new Date().getUTCFullYear() - 17;
            return Array(now - (now - 100)).fill('').map((v, idx) => now - idx);
        },

        getPasswordInputType() {
            return this.showPassword ? 'text' : 'password';
        }
    }
}
</script>

<style scoped>

</style>
